import { delay, put } from "redux-saga/effects";
import { fetchVRLocationAutocomplete } from "../../../api/v1/autocomplete/fetchVRLocationAutocomplete";
import Logger from "../../../utils/logger";
import { actions } from "../actions";

export function* fetchVRLocationAutocompleteSaga(
  action: actions.IFetchVRLocationAutocomplete
) {
  if (action.queryString.length < 2) {
    yield put(actions.setVacationRentalsLocationCategories([]));
    return;
  }

  yield delay(200);

  try {
    const { categories } = yield fetchVRLocationAutocomplete(
      action.queryString
    );
    yield put(actions.setVacationRentalsLocationCategories(categories));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setVacationRentalsLocationCategories([]));
    yield put(actions.setLocationAutocompleteError(true));
  }
}
